import { STORED_USER } from "../components/constant";

export const useUser = () => {
    const email = localStorage.getItem('email') || '';
    const merchant = localStorage.getItem('merchant') || '';
    const otherDetails = localStorage.getItem(STORED_USER);

    return { email, merchant, otherDetails: otherDetails ? JSON?.parse(otherDetails) ?? null : null };
}